export default "__VITE_ASSET__gJnL90bX__"